import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUserGroup2 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.5264 15.3789C20.7531 16.5674 22.3077 18.8455 22.4824 21.5H21.4805C21.3093 19.2504 19.9936 17.3216 18.1152 16.2939L18.5264 15.3789ZM10 14.5C13.9741 14.5 17.2241 17.591 17.4814 21.5H16.4795C16.2241 18.1438 13.4216 15.5 10 15.5C6.57842 15.5 3.77588 18.1438 3.52051 21.5H2.51855C2.77592 17.591 6.02592 14.5 10 14.5ZM17.9131 4.12305C19.4553 4.97475 20.5 6.61386 20.5 8.5C20.5 10.92 18.7826 12.9356 16.5 13.3984V12.3721C18.2256 11.9279 19.5 10.3646 19.5 8.5C19.5 7.07261 18.752 5.8228 17.6289 5.11523L17.9131 4.12305ZM10 1.5C13.0389 1.5 15.5 3.96114 15.5 7C15.5 10.0389 13.0389 12.5 10 12.5C6.96114 12.5 4.5 10.0389 4.5 7C4.5 3.96114 6.96114 1.5 10 1.5ZM10 2.5C7.51386 2.5 5.5 4.51386 5.5 7C5.5 9.48614 7.51386 11.5 10 11.5C12.4861 11.5 14.5 9.48614 14.5 7C14.5 4.51386 12.4861 2.5 10 2.5Z",
		fill: "currentColor",
		stroke: "currentColor"
	})
});
export default SvgUserGroup2;
